<mat-toolbar [color]="DevSite ? 'warn' : 'primary'" class="maintoolbar">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
        <div *ngIf="User" fxLayout="column" fxLayoutAlign="center start">
            <button type="button" mat-icon-button (click)="ToggleNavMenu()">
                <mat-icon aria-label="Toggle Navigation Menu Button">menu</mat-icon>
            </button>
        </div>
        <span class="mat-display-2 nobottommargin" *ngIf="!SmallSize || !User">DELT&Delta;</span>
        <div fxHide fxShow.gt-md fxLayout="column" fxLayoutAlign="end start">
            <span class="mat-subheading-1 nobottommargin">Dual Enrollment Link to Advisors</span>
        </div>
        <div *ngIf="DevSite === true && !SmallSize">DEVELOPMENT SITE</div>
    </div>
    <span class="navspacer"></span>
    <app-user-info *ngIf="User" [user]="User"></app-user-info>
    <button
        fxHide
        fxShow.gt-xs
        type="button"
        class="noprint"
        mat-icon-button
        aria-label="About DELTA"
        title="About..."
        (click)="ToolbarAbout()"
    >
        <mat-icon>help</mat-icon>
    </button>
    <button type="button" class="noprint" mat-icon-button *ngIf="User" (click)="ToolbarLogout()" aria-label="Logout" title="Logout">
        <mat-icon>exit_to_app</mat-icon>
    </button>
</mat-toolbar>
<mat-sidenav-container style="height: 100%">
    <mat-sidenav class="mat-elevation-z5" *ngIf="User" [mode]="SmallSize ? 'over' : 'side'" [opened]="MenuOpen">
        <!-- <button mat-mini-fab class="example-fab" (click)="sidenav.toggle()">
      <mat-icon>add</mat-icon>
    </button> -->
        <app-nav-menu
            [items]="MenuItems"
            [logout]="LogoutFn"
            [about]="AboutFn"
            [user]="User"
            (navigate)="Navigate($event)"
        ></app-nav-menu>
    </mat-sidenav>
    <div class="appcontents" [class.whitebackground]="!!User" *ngIf="ViewReady">
        <div class="devbar" *ngIf="DevSite === true && SmallSize">
            <div>Development Site</div>
        </div>
        <div class="updatebar" *ngIf="UpdateAvailable === true">
            <button type="button" mat-button color="accent" (click)="GetUpdate()">
                A site update is available. Click here for details.
            </button>
        </div>
        <div
            class="routerwrapper"
            [class.updatebarheight]="UpdateAvailable === true"
            [class.devbarheight]="DevSite === true"
            fxLayout="column"
            fxLayoutAlign="start stretch"
        >
            <div>
                <div
                    class="innerwrapper"
                    [class.hasuser]="User"
                    fxLayout="row"
                    fxLayoutAlign="start center"
                    fxLayoutGap="15px"
                    fxLayout.lt-md="column"
                    fxLayoutAlign.lt-md="start stretch"
                >
                    <div
                        *ngIf="User"
                        fxLayout="row"
                        fxLayoutAlign="start center"
                        fxLayoutGap.gt-sm="30px"
                        fxLayout.lt-md="column"
                        fxLayoutAlign.lt-md="start stretch"
                    >
                        <div class="mat-title">
                            <span
                                *ngIf="
                                    User &&
                                    (User.IsParent ||
                                        User.IsCounselor ||
                                        User.IsAdvisor ||
                                        User.IsCollegeAdmin ||
                                        User.IsCollegeSupport ||
                                        User.IsDistrictAdmin ||
                                        User.IsDeveloper) &&
                                    SelectedStudent
                                "
                                >Student: {{ SelectedStudent.FirstName | titleCase }} {{ SelectedStudent.LastName | titleCase }}</span
                            >
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                            <span class="mat-title" *ngIf="!SmallDisplay">Polk County School Year</span>
                            <span class="mat-title" *ngIf="SmallDisplay">PCSB Year</span>
                            <mat-form-field floatLabel="never">
                                <mat-select
                                    class="mat-title"
                                    aria-label="School year selection list"
                                    [ngModel]="SelectedSchoolYear"
                                    (change)="UpdateSelectedYear($event)"
                                >
                                    <mat-option *ngFor="let year of AllSchoolYears" [value]="year">{{ year | schoolYear }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div
                        *ngIf="User && (User.IsDistrictAdmin || User.IsDeveloper) && ShowCollegeFilter"
                        fxLayout="row"
                        fxLayoutAlign="start center"
                        fxLayoutGap="15px"
                    >
                        <span class="mat-title">College </span>
                        <mat-form-field>
                            <mat-select
                                class="mat-title"
                                aria-label="College selection list"
                                [(ngModel)]="AdminCollegeID"
                                (change)="UpdateAdminCollege($event)"
                            >
                                <ng-container *ngFor="let col of AvailableColleges">
                                    <mat-option *ngIf="col.Active" [value]="col.CollegeID">{{ col.CollegeName }}</mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div fxFlex>
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</mat-sidenav-container>



// WEBPACK FOOTER //
// ./src/app/app.component.html